import { LandingAdvertisement } from '../../../../components/_external-pages/landing';
import { ButtonContentProps } from '../../../../@types/components-overview';

const title = 'Refiere y gana';
const subtitle = 'Participa en nuestro programa de referidos y obtén hasta $100,000 pesos.';
const subtitleBold = '¡Entre más refieras, más ganas!';

const buttonss: ButtonContentProps = {
  variant: 'contained',
  size: 'medium',
  color: 'inherit',
  text: 'Conocer más',
  to: '/refiere-y-gana',
  href: ''
};

const buttons: ButtonContentProps[] = [buttonss];

export const HomeFloatingImg = () => {
  return (
    <LandingAdvertisement
      title={title}
      subtitle={subtitle}
      subtitleBold={subtitleBold}
      buttons={buttons}
      showAnimation={true}
    />
  );
};
